<template>
  <div class="the-func" v-show="showTools">
    <div class="title">
      <div class="text">常用工具</div>
<!--      <div class="clear" @click="moretool">更多<img src="../assets/img/index/more.png" alt=""></div>-->
    </div>
    <div class="list">
      <div class="list-item" v-for="(tool, index) in tools" :key="index" @click="goto(tool.url)">
        <img :src="tool.icon" alt="">
        {{ tool.name }}
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "the-tool",
  mixins: [],
  props: {
    
  },
  components: {},
  filters: {
    
  },
  computed: {
    ...mapState({
      // 是否开启常用工具
      showTools: (state) => state.business.sysConfig.showTools,
      // 常用工具列表
      tools: (state) => state.business.sysConfig.tools,
    }),
  },
  data() {
    return {
      
    }
  },
  methods: {
    moretool(){

    },
    goto(url) {
      window.open(url, '_blank')
    }
  },
  mounted() { }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/_var.scss';

.the-func {
  padding: 12px 16px 0 16px;

  .title {
    font-size: 18px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .text{
      cursor: pointer;
    }
    .clear{
      font-weight: 400;
      font-size: 14px;
      line-height: 100%;
      cursor: pointer;
      display: flex;
      align-items: center;
      color: #4550b9;
    }
    img {
      transform: scale(1);
      transition: .2s ease-in-out;
      &:hover {
        transform: scale(1.2);
        transition: .2s ease-in-out;
      }
    }
  }


  .list {
    height: 155px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 25px;
    row-gap: 6px;
    .list-item{
      display: flex;
      align-items: center;
      width: 86px;
      height: 75px;
      gap: 3px;
      row-gap: 8px;
      flex-direction: column;
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 14px;
      line-height: 100%;
      letter-spacing: 0%;
      color: #424242;
      cursor: pointer;

      img {
        width: 36px;
      }
    }
  }
}



</style>
